import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M853.333333,309.653333 L853.333333,416.426667 L106.666667,416.426667 L106.666667,1459.62667 L372.016412,1459.52878 L371.946667,1706.66667 L701.5892,1459.52878 L1610.24,1459.62667 L1610.24,853.333333 L1716.90667,853.333333 L1716.98189,1566.19545 L737.141594,1566.19545 L265.349746,1920 L265.349746,1566.19545 L0,1566.19545 L0,309.653333 L853.333333,309.653333 Z M1677.01333,0 L1756.86275,79.8494118 L1514.49098,322.221176 L1756.86275,564.705882 L1677.01333,644.555294 L1434.52863,402.183529 L1192.15686,644.555294 L1112.30745,564.705882 L1354.67922,322.221176 L1112.30745,79.8494118 L1192.15686,0 L1434.52863,242.371765 L1677.01333,0 Z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconCommentsOffLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCommentsOffLine, _Component);

  var _super = _createSuper(IconCommentsOffLine);

  function IconCommentsOffLine() {
    _classCallCheck(this, IconCommentsOffLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCommentsOffLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCommentsOff",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCommentsOffLine.displayName = "IconCommentsOffLine";
  return IconCommentsOffLine;
}(Component);

IconCommentsOffLine.glyphName = 'comments-off';
IconCommentsOffLine.variant = 'Line';
IconCommentsOffLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCommentsOffLine;
export { IconCommentsOffLine };